import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  readonly isLoading = signal<boolean>(false);

  private count = 0;
  private showTimer?: ReturnType<typeof setTimeout>;
  private hideTimer?: ReturnType<typeof setTimeout>;
  private shownAt = 0;

  private readonly showDelayMs = 200;
  private readonly minVisibleMs = 300;

  increment(immediate = false): void {
    // Om vi håller på att gömma spinnern, avbryt gömningen!
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }

    this.count++;
    if (this.count === 1) {
      if (immediate) {
        this._doShow();
      } else {
        this.showTimer = setTimeout(() => {
          this.showTimer = undefined;
          this._doShow();
        }, this.showDelayMs);
      }
    }
  }

  decrement(): void {
    if (this.count <= 0) return;
    this.count--;

    if (this.count === 0) {
      // Om spinnern aldrig hann visas, avbryt visningen
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = undefined;
        this.isLoading.set(false);
        return;
      }

      const elapsed = Date.now() - this.shownAt;
      const remaining = Math.max(0, this.minVisibleMs - elapsed);

      this.hideTimer = setTimeout(() => {
        this.hideTimer = undefined;
        if (this.count === 0) {
          this.isLoading.set(false);
        }
      }, remaining);
    }
  }

  // Tvingar bort spinnern DIREKT när fel-modalen öppnas
  forceHide(): void {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = undefined;
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }
    this.count = 0;
    this.isLoading.set(false);
  }

  showImmediate(): void {
    this.increment(true);
  }

  hide(): void {
    this.decrement();
  }

  reset(): void {
    this.forceHide();
  }

  private _doShow(): void {
    this.shownAt = Date.now();
    this.isLoading.set(true);
  }
}
